module.exports = __webpack_public_path__ + "img/bca.1cd98706.png";